import { tickerItems } from '@/mocks/home';

export default function TopBar() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="mx-auto flex max-w-[1280px] items-center gap-3 px-4 py-2 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
          <i className="ri-radar-line text-sm" aria-hidden="true" />
          实时播报
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track">
            {loop.map((item, index) => (
              <span key={`${item}-${index}`} className="mr-10 text-xs text-background-200">
                <i className="ri-record-circle-line mr-1.5 text-[8px] align-middle text-primary-400" aria-hidden="true" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}